import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



const styles = theme => ({
    root: {
      flexGrow: 1,
      minWidth: 200,
      minHeight: 300
    },
    textArea:{
       marginBottom: theme.spacing.unit
    }
  });
  

class BobDialog extends React.Component {

    state = {
    
    };

  render() {
      const { classes, open, close  } = this.props

    return (
  
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
        >
        <DialogActions>
      </DialogActions>
          <DialogTitle id="form-dialog-title">Let's Get Started!</DialogTitle>
          <DialogContent>
          <DialogContentText className={classes.textArea}>
          Agents/Users can now sign up by chatting with Sonic Bob, our automated customer service bot. After clicking ok, a chat with Bob will open in a new window. Start your conversation with Bob by saying 'Hi'!
          </DialogContentText>
          <DialogContentText className={classes.textArea}>
          When completed, sign in to your agent dashboard by using the email you submitted in the chat and the temporary password given to you by Bob. You will then be prompted to create a new password that is easier for you to remember. 
        </DialogContentText>
        <DialogContentText className={classes.textArea}>
        Also, be sure to look for a welcome email from us that will provide additional information to help navigate the agent dashboard once signed in.
      </DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={() => {close(true)}}> 
          Cancel
        </Button>
          <Button onClick={() => {close(false)}} color="primary"> 
          Click Here to Get Started with Sonic Bob →
        </Button>
          </DialogActions>
        </Dialog>

    );
  }
}

//add right arrow to the get started bob button
//handleSubmitForgotPassword

BobDialog.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
export default withStyles(styles)(BobDialog);


// WEBPACK FOOTER //
// ./src/components/Account/BobDialog.js